import React from 'react';
import styled from 'styled-components';
import SearchIcon from './SearchIcon';
import CloseIcon from './CloseIcon';

const Container = styled.div`
  background-color: #f3f3ed;
  height: 45px;
  border-radius: 8px;
  padding: 0 16px 0 23px;
  flex-direction: row;
  align-items: center;
  display: flex;
  margin-inline: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const TextInput = styled.input`
  outline: none;
  border: none;
  flex: 1;
  background-color: transparent;
  font-size: 16px;
`;

const SearchIconContainer = styled.span`
  padding-right: 12px;
  margin-top: 3px;
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;

interface Props {
  text?: string;
  placeholder?: string;
  onSearch?: (text: string) => void;
  onClose?: () => void;
}

const Search: React.FC<Props> = ({
  text,
  placeholder = 'Search',
  onSearch,
  onClose,
}) => {
  return (
    <Container>
      {!text && (
        <SearchIconContainer>
          <SearchIcon />
        </SearchIconContainer>
      )}
      <TextInput
        placeholder={placeholder}
        value={text}
        onChange={(e) => onSearch?.(e.currentTarget.value)}
      />
      {text && <CloseIcon onClick={onClose} />}
    </Container>
  );
};

export default Search;
